import React from 'react';
import useHover from 'react-use-hover';
import cx from 'classnames';
import { animated, useSpring } from 'react-spring';

const hoverImageMaskStyle: React.CSSProperties = {
  backgroundBlendMode: 'multiply',
  backgroundImage: `linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.72),
    rgba(0, 0, 0, 0.25) 50%,
    rgba(0, 0, 0, 0.68) 99%
  )`,
};

export interface HoverImage {
  children: React.ReactNode;
  className?: string;
}

export default function HoverImage({ children, className }: HoverImage) {
  const [hovered, hoverProps] = useHover({
    mouseEnterDelayMS: 0,
    mouseLeaveDelayMS: 0,
  });
  const hoverImageMaskProps = useSpring({ opacity: Number(hovered) });

  const HoverOverlay = () => (
    <animated.div
      className={
        'inset-0 rounded-md w-full h-full absolute pointer-events-none'
      }
      style={{ ...hoverImageMaskStyle, ...hoverImageMaskProps }}
    />
  );

  return (
    <div className={cx('relative', className)} {...hoverProps}>
      {children}
      <HoverOverlay />
    </div>
  );
}
